import React, { useEffect } from "react";
import { Box, ColorPaletteProp, Sheet, Table } from "@mui/joy";
import { LoadingView, PageTitle, StatusBadge } from "../../../components";
import { connect, useDispatch } from "react-redux";
import { apiDetailsRequest, apiDetailsReset } from "../../../store/actions";
import { STATUS } from "../../../constant";
import { formatDate } from "../../../utils";
import { toast } from "react-toastify";

function ViewLoggedInApiDetails({
  loginResult,

  apiDetailsStatus,
  apiDetailsResult,
  apiDetailsErrorMessage,
}) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(apiDetailsRequest(loginResult?.token, {}));
  }, [dispatch, loginResult]);

  const checkLoading = () => {
    if (apiDetailsStatus === STATUS.LOADING) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    if (apiDetailsStatus === STATUS.ERROR) {
      toast.error(apiDetailsErrorMessage, {
        toastId: "apiDetailsError",
      });

      dispatch(apiDetailsReset());
    }
  }, [apiDetailsErrorMessage, apiDetailsStatus, dispatch]);

  return (
    <Box>
      <PageTitle title={"API Access View"} />

      <LoadingView loading={checkLoading()} />

      <Sheet
        variant="outlined"
        sx={{
          mx: 2,
          mb: 2,
          p: 2,
          borderRadius: "sm",
          overflow: "auto",
          flex: 1,
          minHeight: 0,
        }}
      >
        <Table size="sm" sx={{ "& td": { py: 1.5 } }}>
          <tbody>
            <tr>
              <td
                style={{
                  width: "200px",
                  fontWeight: "bold",
                  verticalAlign: "top",
                }}
              >
                Client ID:
              </td>
              <td style={{ wordBreak: "break-all" }}>
                {apiDetailsResult?.client_id}
              </td>
            </tr>
            <tr>
              <td style={{ fontWeight: "bold", verticalAlign: "top" }}>
                Secret Key:
              </td>
              <td style={{ wordBreak: "break-all" }}>
                {apiDetailsResult?.secret_key}
              </td>
            </tr>
            <tr>
              <td style={{ fontWeight: "bold", verticalAlign: "top" }}>
                Owner Name:
              </td>
              <td>{apiDetailsResult?.owner_name}</td>
            </tr>
            <tr>
              <td style={{ fontWeight: "bold", verticalAlign: "top" }}>
                Email:
              </td>
              <td>{apiDetailsResult?.email}</td>
            </tr>
            <tr>
              <td style={{ fontWeight: "bold", verticalAlign: "top" }}>
                AES Key:
              </td>
              <td style={{ wordBreak: "break-all" }}>
                {apiDetailsResult?.aes_key}
              </td>
            </tr>
            <tr>
              <td style={{ fontWeight: "bold", verticalAlign: "top" }}>
                FSP Code:
              </td>
              <td>{apiDetailsResult?.fsp_code}</td>
            </tr>
            <tr>
              <td style={{ fontWeight: "bold", verticalAlign: "top" }}>
                Access Token:
              </td>
              <td style={{ wordBreak: "break-all" }}>
                {apiDetailsResult?.access_token}
              </td>
            </tr>
            <tr>
              <td style={{ fontWeight: "bold", verticalAlign: "top" }}>
                Access Token Expire:
              </td>
              <td>{formatDate(apiDetailsResult?.access_token_expire)}</td>
            </tr>
            <tr>
              <td style={{ fontWeight: "bold", verticalAlign: "top" }}>
                Created At:
              </td>
              <td>{formatDate(apiDetailsResult?.created_at)}</td>
            </tr>
            <tr>
              <td style={{ fontWeight: "bold", verticalAlign: "top" }}>
                Created By:
              </td>
              <td>{apiDetailsResult?.created_by}</td>
            </tr>
            <tr>
              <td style={{ fontWeight: "bold", verticalAlign: "top" }}>
                Approved At:
              </td>
              <td>{formatDate(apiDetailsResult?.approved_at)}</td>
            </tr>
            <tr>
              <td style={{ fontWeight: "bold", verticalAlign: "top" }}>
                Approved By:
              </td>
              <td>{apiDetailsResult?.approved_by}</td>
            </tr>
            <tr>
              <td style={{ fontWeight: "bold", verticalAlign: "top" }}>
                Status:
              </td>
              <td>
                <StatusBadge
                  color={
                    {
                      1: "success",
                      2: "warning",
                      3: "neutral",
                      4: "danger",
                      5: "neutral",
                    }[apiDetailsResult?.status] as ColorPaletteProp
                  }
                >
                  {
                    {
                      1: "Active",
                      2: "Inactive",
                      3: "Pending Approval",
                      4: "Rejected",
                      5: "Pending Additional",
                    }[apiDetailsResult?.status]
                  }
                </StatusBadge>
              </td>
            </tr>
          </tbody>
        </Table>
      </Sheet>
    </Box>
  );
}

const mapStateToProps = ({ api, auth }) => {
  const { otpResult: loginResult } = auth;
  const { apiDetailsStatus, apiDetailsResult, apiDetailsErrorMessage } = api;

  return {
    loginResult,

    apiDetailsStatus,
    apiDetailsResult,
    apiDetailsErrorMessage,
  };
};

export default connect(mapStateToProps, {})(ViewLoggedInApiDetails);
